const STEPS = ['Intake', 'In Queue', 'Repair', 'Ready', 'Complete'] as const;

export function PortalProgress({ index }: { index: number }) {
  if (index < 0) {
    return <p className="text-sm text-slate-500">This ticket is no longer active.</p>;
  }

  return (
    <div className="space-y-2">
      <div className="flex gap-1">
        {STEPS.map((_, i) => (
          <div
            key={STEPS[i]}
            className={[
              'h-2 flex-1 rounded-full transition',
              i <= index ? 'bg-[#1B4F8A]' : 'bg-slate-200',
            ].join(' ')}
          />
        ))}
      </div>
      <div className="flex justify-between text-[10px] font-semibold uppercase tracking-wide text-slate-500">
        {STEPS.map((label, i) => (
          <span key={label} className={i === index ? 'text-[#1B4F8A]' : undefined}>
            {i < index ? '✓ ' : i === index ? '● ' : '○ '}
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
